import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { getDraftContentAppearanceProperty } from './ContentAppearanceQuery.graphql.ts';
import type {
	getDraftContentAppearanceProperty as getDraftContentAppearancePropertyType,
	getDraftContentAppearancePropertyVariables as getDraftContentAppearancePropertyVariablesType,
} from './__types__/getDraftContentAppearanceProperty.ts';

export const preloadDraftContentAppearance = (
	contentId: getDraftContentAppearancePropertyVariablesType['contentId'],
	useCache: boolean = true,
) => {
	return query<
		getDraftContentAppearancePropertyType,
		getDraftContentAppearancePropertyVariablesType & { cacheBuster?: number }
	>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getDraftContentAppearanceProperty,
		variables: {
			contentId,
			status: ['current', 'draft'],
			...(!useCache ? { cacheBuster: Date.now() } : {}),
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
};
